import { useState, useEffect, useContext } from "react";
import { MyContext } from "../../MyContext";
import Link from "../Link";
import logo_mynextID from "../../img/logo_mynextID.svg";
import { SidebarData, SidebarUser } from "./SidebarData";
import { useNavigate } from "react-router-dom";
import { useSession } from "../session/Context";
import Footer from "../Footer/Footer";

//let serverUrl = window.location.origin;

/* interface Sidebar {
  defaultPage?: string;
  onPage: string;
  onPageChange: (current: string) => void;
} */

/* let pathname = window.location.pathname;
if (pathname === "") {
  pathname = "/";
} */



function Sidebar () {
  // Highlight navigation
  const { email, brand_name, is_admin, brand } = useSession();
  const navigate = useNavigate();
  
  const { onPage, setOnPage } = useContext(MyContext)!;

  return (
    <div className="sidebar m-hide">
      <div className="sidebar__title">
        <div className="sidebar__img">
          <div id="logoIcon">
            <img
              src={logo_mynextID}
              alt="logo"
              className="clickable"
              onClick={() => {
                setOnPage("dashboard");
                navigate("/dashboard");
              }}
            />
          </div>
        </div>
        <i className="fa fa-times" id="sidebarIcon" aria-hidden="true"></i>
      </div>

      <div id="sidebar-profile" className="sidebar__profile">
        <div className="sidebar__user">
          <div id="user__title">
            <h1>Company: {brand_name}</h1>
            <p>Email: {email}</p>
            {/* <p>Here will be name of user - provided on onboarding form</p> */}
          </div>
          {/*<div id="user__profile"><img src={logo} alt="logo" /></div>*/}
        </div>

        {/*  {is_admin ? (
          <ul className="sidebar-list">
            {SidebarUser.map((valUser, keyUser) => {
                 if(valUser.title !== 'Create ghost brand' || brand ===''){
                     return (
                         <li
                         key={keyUser}
                         className="row"
                         id={props.onPage == valUser.link ? "active" : ""}
                         >
                         <Link
                             to={valUser.link}
                             onClick={() => {
                             props.onPageChange(valUser.link);
                             }}
                         >
                             <div id="title">{valUser.title}</div>
                         </Link>
                         </li>
                     );
                 }
            })}
          </ul>
        ) : (
          <></>
        )} */}
      </div>

      <div id="sidebar-menu" className="sidebar__menu">
        <ul className="sidebar-list">
          {SidebarData.map((val, key) => {
            return (
              <li
                key={key}
                className="row"
                id={onPage == val.link ? "active" : ""}

                //if (props.onPage == undefined) { props.defaultPage == val.link ? "active" : "" } else if (props.onPage == val.link) { "active" } else { "" }
              >
                <Link
                  to={val.link}
                  onClick={() => {
                    setOnPage(val.link);
                  }}
                >
                  <div id="title">{val.title}</div>
                </Link>
              </li>
            );
          })}
        </ul>

        <ul className="sidebar-list">
          <li
            key={"Logout"}
            className="row"
            id={onPage == "logout" ? "active" : ""}
          >
            <Link
              to={"/logout"}
              onClick={() => {
                setOnPage("/logout");
              }}
            >
              <div id="logout">Logout</div>
            </Link>
          </li>
        </ul>
      </div>
      <Footer />
    </div>
  );
};

export default Sidebar;
